import MResponseFlowItem from './index.vue';

MResponseFlowItem.install = app => {
  app.component(MResponseFlowItem.name, MResponseFlowItem);
};

export default MResponseFlowItem;
